import React, { useContext, useEffect, useRef, useState } from "react";
import { RecadastramentoContext } from "@contexts";
import { FormulariosService, PlanoService, RecadastramentoService } from "@services";
import { DependenteEntidade, PlanoVinculadoEntidade } from "@entidades";
import { LoadingComponent } from "@components";
import { Alert, Button, Col, Row } from "@intech/web-ui";
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaDownload } from "react-icons/fa";
import { DMN_PLANO } from "@src/domains";

interface IProps {
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
  voltar: (PassoEspecifico?: number | null) => Promise<void>;
}

export const Passo6: React.FC<IProps> = ({
  avancar,
  voltar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);

  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [ListaDependente, setListaDependente] = useState<Array<DependenteEntidade>>([]);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        // const dados = await context.buscarDadosParticipante();
        // const dadosOriginais = await context.buscarDadosOriginais();

        const Planos = await PlanoService.Buscar();

        const ListaDependente = await RecadastramentoService.BuscarDependentes(Planos[0].CD_PLANO);

        setListaDependente(ListaDependente);
        setPlano(Planos[0]);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


  async function handleVoltar() {
    try {
      voltar();
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErro(messsage);
    }
  }

  async function handleAvancar() {
    try {
      avancar();
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErro(messsage);
    }
  }

  async function BaixarDesignacaoDependentes() {
    try {
      const plano = (await PlanoService.Buscar())[0];
      const relatorio = await FormulariosService.BaixarDesignacaoDependentes(plano.CD_PLANO, false);

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "designacao_dependentes.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "designacao_dependentes.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      const err = e["response"] ? e["response"]["data"] : e;
      let erro = err;
      if (typeof err === "object") {
        erro = await err.text();
      }
      setErro(erro);
    }
  };

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          <Alert type={"info"}>{"No caso de alteração do beneficiário favor baixar o arquivo, imprimir o formulário e assinar e, em seguida, anexá-lo."}</Alert>

          {ListaDependente.length > 0 && <>
            <table className={"table table-responsive"}>
              <thead>
                <tr>
                  <th style={{ width: "250" }}>Nome</th>
                  <th className={"text-center"}>CPF</th>
                  <th className={"text-center"} style={{ width: "150" }}>Data de Nascimento</th>
                  <th className={"text-center"}>Sexo</th>
                  <th className={"text-center"} style={{ width: "150" }}>Grau de Parentesco</th>
                  {Plano.CD_PLANO !== DMN_PLANO.BENEFICIO_DEFINIDO && <th className={"text-center"}>% Pensão por Morte</th>}
                </tr>
              </thead>
              <tbody>{ListaDependente.map((dep: DependenteEntidade, index: number) => {
                return (
                  <tr key={index}>
                    <td>{dep.NOME_DEP}</td>
                    <td className={"text-center"}>{dep.CPF || "-"}</td>
                    <td className={"text-center"}>{dep.DT_NASC_DEP}</td>
                    <td className={"text-center"}>{dep.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}</td>
                    <td className={"text-center"}>{dep.DS_GRAU_PARENTESCO}</td>
                    {Plano.CD_PLANO !== DMN_PLANO.BENEFICIO_DEFINIDO && <td className={"text-center"}>{dep.PERC_PECULIO}</td>}
                  </tr>
                );
              })}</tbody>
            </table>
          </>}

          {ListaDependente.length === 0 && <Alert type={"info"}>{"Nenhum beneficiário cadastrado."}</Alert>}

          <Row>
            <Col>
              <Button
                className={"mb-2"}
                type={"success"}
                title={"Baixar Designação de Dependentes"}
                onClick={BaixarDesignacaoDependentes}
                icon={<FaDownload />}
                loadingText={"Baixando..."}
                usesLoading
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                type={"secondary"}
                title={"Voltar"}
                icon={<FaAngleDoubleLeft />}
                onClick={handleVoltar}
                loadingText={"Voltando..."}
                usesLoading
                block
                iconRight
              />
            </Col>

            <Col>
              <Button
                type={"primary"}
                title={"Continuar"}
                icon={<FaAngleDoubleRight />}
                onClick={handleAvancar}
                loadingText={"Continuando..."}
                usesLoading
                block
              />
            </Col>
          </Row>
        </>)}
    </>
  );
}
